<template>
  <div class="app">
    <div class="app-body">
      <Sidebar :navItems="nav" />
      <main class="main">
        <AppHeader />
        <!--<breadcrumb :list="list"/>-->
        <div class="container-fluid mt-3">
          <WelcomeModal ref="welcomeModal" v-if="!user.shipper_id"></WelcomeModal>
          <NewFeature ref="newFeature" v-if="user.shipper_id"></NewFeature>
          <Suspended ref="suspended" v-if="user.shipper_id"></Suspended>
          <router-view></router-view>
        </div>
      </main>
      <AppAside />
    </div>
    <!--<AppFooter/>-->
  </div>
</template>

<script>
import WS from "@adonisjs/websocket-client";
import { mapGetters, mapMutations } from 'vuex';
import nav from '../_nav';
import { Header as AppHeader, Aside as AppAside, Footer as AppFooter, Breadcrumb } from '../components/';
import WelcomeModal from '../components/WelcomeModal';
import NewFeature from '../components/Modals/NewFeature';
import Suspended from '../components/Modals/Suspended';

import Sidebar from '../components/Sidebar';

import moment from 'moment'

export default {
  name: 'full',
  components: {
    AppHeader,
    Sidebar,
    AppAside,
    AppFooter,
    Breadcrumb,
    WelcomeModal,
    NewFeature,
    Suspended,
  },
  data() {
    return {
      nav: nav.items
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser',
      ws: 'getWS',
    }),
    name() {
      return this.$route.name
    },
    list() {
      return this.$route.matched
    }
  },
  async mounted() {
    //this.$refs.welcomeModal.show();
    // this.ws.on("open", ()=> {
    //   console.info("WS opened");
    //   console.log(`subscribing to ebay:${this.user.id}`)
    //   this.ws.subscribe(`ebay:${this.user.id}`);
    //   this.ws.subscribe(`batchPrint:${this.user.id}`);
    // });
    // this.ws.on("close", ()=> {
    //   console.info("WS closed");
    //   this.setWS(null)
    // });
    //SUSPENDED
    if (this.user.suspend) {
      this.$refs.suspended.show()
    }
    // check new feature
    let new_feature = process.env.MIX_NEW_FEATURE
    let local_new_feature = localStorage.getItem('new_feature')
    // console.log("new feature", typeof(new_feature),new_feature.length);
    // console.log("local new feature", local_new_feature);
    if (new_feature.length) {
      if (!local_new_feature) {
        this.$refs.newFeature.show()
      } else {
        new_feature = moment(new_feature)
        local_new_feature = moment(local_new_feature)
        if (local_new_feature < new_feature) {
          this.$refs.newFeature.show()
        }
      }
    }
  },
  methods: {
    ...mapMutations(["setWS"])
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/containers/Full.vue